import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Github, ArrowUpRight } from 'lucide-react';
import Logo from './Logo';
import { companyInfo, services, navLinks } from '../data/mock';

const social = [[Linkedin, 'https://linkedin.com', 'LinkedIn'], [Twitter, 'https://twitter.com', 'Twitter'], [Github, 'https://github.com', 'GitHub']];

const Footer = () => (
  <footer className="relative overflow-hidden border-t border-[var(--line)] bg-[var(--surface)]">
    <div className="max-w-6xl mx-auto px-6 pt-20 pb-10">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo className="h-14 w-auto" />
          <p className="mt-6 max-w-sm text-[var(--muted)] leading-relaxed">{companyInfo.description}</p>
          <div className="mt-8 flex gap-3">
            {social.map(([Icon, href, label]) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-11 h-11 grid place-items-center rounded-full border border-[var(--line-strong)] text-[var(--muted)] hover:text-white hover:bg-[var(--red)] hover:border-[var(--red)] transition-all"><Icon className="w-4 h-4" /></a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-mono-label text-[var(--red)] mb-6">Services</h4>
          <ul className="space-y-3 text-sm">
            {services.slice(0, 6).map((s) => (<li key={s.id}><Link to="/services" className="text-[var(--muted)] hover:text-[var(--paper)] transition-colors">{s.title}</Link></li>))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-mono-label text-[var(--red)] mb-6">Company</h4>
          <ul className="space-y-3 text-sm">
            {navLinks.map((l) => (<li key={l.name}><Link to={l.href} className="text-[var(--muted)] hover:text-[var(--paper)] transition-colors">{l.name}</Link></li>))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-mono-label text-[var(--red)] mb-6">Contact</h4>
          <ul className="space-y-3 text-sm text-[var(--muted)]">
            {companyInfo.locations.map((l) => (<li key={l.city}>{l.city}, {l.country}</li>))}
            <li><a href={`mailto:${companyInfo.email}`} className="inline-flex items-center gap-1 text-[var(--paper)] hover:text-[var(--red)] transition-colors">{companyInfo.email}<ArrowUpRight className="w-3 h-3" /></a></li>
            <li><a href={`tel:${companyInfo.phone}`} className="hover:text-[var(--paper)] transition-colors">{companyInfo.phone}</a></li>
          </ul>
        </div>
      </div>

      <p className="font-display text-[18vw] md:text-[9rem] leading-none text-center mt-8 select-none text-transparent" style={{ WebkitTextStroke: '1px var(--line-strong)' }} aria-hidden>enseQure</p>

      <div className="mt-6 pt-6 border-t border-[var(--line)] flex flex-col sm:flex-row justify-between gap-3 font-mono-label text-[var(--muted)]">
        <span>© {new Date().getFullYear()} enseQure Inc. All rights reserved.</span>
        <span>Harare · Johannesburg · Prague</span>
      </div>
    </div>
  </footer>
);

export default Footer;
